import React, { useState } from "react";
import { DemoBusyError, startDemoSession } from "../utils/demoSession";

// Shared "Try the demo" buttons. Used under the demo video on both HowItWorksPage and
// LandingPage (they embed the same video), and on the /demo page.
//
// onTryDemo(role) has to come from App.js: the marketing pages only get onNavigate, which routes
// between unauthed views and cannot log anyone in.
export default function TryDemoCta({ onTryDemo, align = "left", className = "" }) {
  const [busyRole, setBusyRole] = useState("");
  const [error, setError] = useState("");

  async function start(role) {
    if (busyRole) return; // ignore double-clicks - each one would mint another session
    setBusyRole(role);
    setError("");
    try {
      const token = await startDemoSession(role);
      onTryDemo(token, role);
    } catch (err) {
      setError(
        err instanceof DemoBusyError
          ? "The demo is busy right now - please try again in a moment."
          : "The demo is unavailable right now - please try again later."
      );
      setBusyRole("");
    }
  }

  const justify = align === "center" ? "justify-center" : "";

  return (
    <div className={className}>
      <div className={`flex flex-wrap items-center gap-3 ${justify}`}>
        <button
          type="button"
          onClick={() => start("owner")}
          disabled={!!busyRole}
          className="rounded-lg bg-red-600 px-6 py-3 text-base font-semibold text-white shadow-sm hover:bg-red-500 disabled:opacity-60"
        >
          {busyRole === "owner" ? "Starting..." : "Try the demo as a vehicle owner"}
        </button>
        <button
          type="button"
          onClick={() => start("shop")}
          disabled={!!busyRole}
          className="rounded-lg border border-slate-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-6 py-3 text-base font-semibold text-blue-700 dark:text-blue-300 hover:bg-slate-50 dark:hover:bg-gray-700 disabled:opacity-60"
        >
          {busyRole === "shop" ? "Starting..." : "Try the demo as a shop"}
        </button>
      </div>
      <p className={`mt-3 text-sm text-slate-500 dark:text-gray-400 ${align === "center" ? "text-center" : ""}`}>
        No account needed. Sample data, shared with anyone else trying it, and wiped regularly.
      </p>
      {error ? (
        <p role="status" className={`mt-2 text-sm font-medium text-red-700 dark:text-red-300 ${align === "center" ? "text-center" : ""}`}>
          {error}
        </p>
      ) : null}
    </div>
  );
}
